import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {callAction} from 'client/framework';
import {history} from 'client/history';
import schoolAdministrationActions from '../SchoolAdministrationActions';
import sessionStore from 'client/Session/SessionStore';
import schoolAdministrationStore from '../SchoolAdministrationStore';
import SchoolSearchGroupedInputs from 'sg/Dropdowns/SchoolSearchGroupedInputs/SchoolSearchGroupedInputs.react';
import LoadingIndicator from 'generic/LoadingIndicator.react';
import Pagination from 'generic/PaginationV2/Pagination.react';
import {SchoolModelV2} from 'resources/School/V2/School.model';
import {SchoolModelV4} from 'resources/GeneratedModels/School/SchoolModel.v4';

import './school-list.scss';
const searchDropdownStoreName = 'SchoolListSchoolSearchStore';

export default class SchoolList extends React.Component {
  UNSAFE_componentWillMount() {
    callAction(schoolAdministrationActions.SET_ACTIVE_SCHOOL_ID, null);
  }

  onSchoolSelection(school) {
    const schoolId = school.getId();
    callAction(schoolAdministrationActions.SET_ACTIVE_SCHOOL_ID, schoolId);
    history.pushState(null, `/school-admin/${schoolId}`);
  }

  generateSchoolSearch() {
    return (
      <div className='schools-list__search-wrapper'>
        <SchoolSearchGroupedInputs
          customClearOption={SchoolModelV4.getDefaultModel()}
          disableClear={true}
          label='School or Organization Name'
          onClick={this.onSchoolSelection}
          countryDropdownStoreName='SchoolListCountryDropdownStore'
          schoolSearchDropdownStoreName={searchDropdownStoreName}
        />
      </div>
    );
  }

  generateSchoolList() {
    const schools = schoolAdministrationStore.getPageOfSchools();
    if (!schools || schools.isEmpty()) {
      return <div>You don{"'"}t have any schools yet.</div>;
    }

    return schools.map((school) => {
      return <PopulatedSchool key={school.getId()} school={school} />;
    });
  }

  generatePagination() {
    const pagination =
      schoolAdministrationStore.getSchoolsTotalPages() > 1 ? (
        <Pagination
          storeName={schoolAdministrationStore.getPaginationStore().getName()}
          totalPages={schoolAdministrationStore.getSchoolsTotalPages()}
        />
      ) : null;

    return <div className='schools-list__schools-pagination-wrapper'>{pagination}</div>;
  }

  render() {
    let content;
    let title;
    let pagination;

    if (sessionStore.isSuper()) {
      title = 'Select a School';
      content = this.generateSchoolSearch();
    } else {
      if (!schoolAdministrationStore.isSchoolDataReady()) {
        return <LoadingIndicator />;
      }
      title = 'All Schools';
      content = this.generateSchoolList();
      pagination = this.generatePagination();
    }

    return (
      <div className='schools-list max-width'>
        <div className='schools-list__title'>{title}</div>
        <div className='schools-list__content'>
          {content}
          {pagination}
        </div>
      </div>
    );
  }
}

export class PopulatedSchool extends React.Component {
  static propTypes = {
    school: PropTypes.instanceOf(SchoolModelV2)
  };

  render() {
    const {school} = this.props;

    return (
      <div className='schools-list__school'>
        <Link
          className='schools-list__school-body card card--hover'
          onClick={() => {
            callAction(schoolAdministrationActions.SET_ACTIVE_SCHOOL_ID, school.getId());
          }}
          to={`/school-admin/${school.getId()}/dashboard`}
        >
          <span className='schools-list__name'>{school.getName()}</span>
          <ul className='schools-list__data-list'>
            <li className='schools-list__data-list-item'>
              <span className='schools-list__data-list-item-highlight'>
                {school.getMeta().getCountOfStudents()}
              </span>{' '}
              students
            </li>
            <li className='schools-list__data-list-item'>
              <span className='schools-list__data-list-item-highlight'>
                {school.getMeta().getCountOfApprovedTeachers()}
              </span>{' '}
              teachers
            </li>
          </ul>
        </Link>
      </div>
    );
  }
}
